import api from "./api";
import moment from 'moment'

const limit = 99999;

export const createCount = async (Dto: {
    name: string;
    type: string;
    warehouseId: number;
    selectedWarehouseId: number | null
}) => {
    const url = `/counts/?limit=${limit}&warehouse=${Dto.selectedWarehouseId}`;
    const currentDate = moment().format('MM/DD/YYYY HH:mm:ss')

    return await api.post(url, {
        name: Dto.name,
        type: Dto.type,
        date: currentDate,
        warehouseId: Dto.warehouseId
    });
};


export const editCount = async (Dto: {
    id: number;
    date: string;
}) => {
    const url = `/counts/${Dto.id}?limit=${limit}`;

    return await api.put(url, {
        date: Dto.date
    });
};


export const deleteCount = async (Dto: {
    id: number;
}) => {
    const url = `/counts/${Dto.id}`;

    return await api.delete(url);
};


export const closeCount = async (Dto: {
    id: number;
}) => {
    const currentDate = moment().format('MM/DD/YYYY HH:mm:ss')
    const url = `/counts/${Dto.id}/close?limit=${limit}`;

    return await api.post(url, {
        closedDate: currentDate
    });
};


export const getCount = async (Dto: {
    id: number;
}) => {
    const url = `/counts/${Dto.id}?limit=${limit}`;

    return await api.get(url);
};


export const getCounts = async (Dto: {
    warehouseId: number | null;
}) => {
    let url = `/counts?`;

    if (Dto.warehouseId !== null) {
        url += `warehouseId=${Dto.warehouseId}&`;
    }

    url += `limit=${limit}`;

    return await api.get(url);
};


export const editCountItem = async (Dto: {
    id: number;
    countDetailId: number;
    quantityOnHand: any | null;
    justificationId: number | null;
}) => {
    const url = `/counts/${Dto.id}/details/${Dto.countDetailId}`;

    return await api.put(url, {
        justificationId: Dto.justificationId,
        // quantityOnHand: parseFloat(Dto.quantityOnHand === "" ? 0 : Dto.quantityOnHand)
        quantityOnHand: Dto.quantityOnHand
    });
};


export const getCountListDetailsByID = async (Dto: {
    id: number;
}) => {
    const url = `/counts/${Dto.id}/details?limit=${limit}`;

    return await api.get(url)
}


// export const exportCountListTemplate = async (Dto: {
//     id: number;
// }) => {
//     const url = `/counts/${Dto.id}/export`

//     return await api.get(url)
// }


// export const importCountListTemplate = async (Dto: {
//     id: number;

// }) => {
//     const url = `/counts/${Dto.id}/import`

//     return await api.post(url)
// }